import React, { useState } from 'react';
import { FURNITURE_PRESETS, FURNITURE_THEME_LABELS } from '../../types/myHome';

const NEW_KEYS = new Set(['piano', 'aquarium', 'teddy', 'arcade', 'mirror', 'snack_cart']);

export default function FurnitureCatalogPicker({ value, onChange }: { value: string; onChange: (key: string) => void }) {
  const [filter, setFilter] = useState('all');
  const items = FURNITURE_PRESETS.filter(item => filter === 'all' || (filter === 'new' ? NEW_KEYS.has(item.key) : (item.theme || 'basic') === filter));
  return <section aria-label="가구 카탈로그" style={{ display: 'grid', gap: 10, minWidth: 0 }}>
    <div style={{ fontSize: 14, fontWeight: 700 }}>판매할 가구 선택 · {FURNITURE_PRESETS.length}종</div>
    <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
      가구 분류
      <select aria-label="가구 분류" value={filter} onChange={event => setFilter(event.target.value)} style={{ flex: 1, minWidth: 0, padding: 8, border: '1px solid #ddd', borderRadius: 8 }}>
        <option value="all">전체 가구</option>
        <option value="new">새 취미·생활 가구 6종</option>
        {Object.entries(FURNITURE_THEME_LABELS).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
      </select>
    </label>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))', gap: 8, maxHeight: 350, overflowY: 'auto', padding: 3 }}>
      {items.map(item => <button key={item.key} type="button" aria-pressed={value === item.key} onClick={() => onChange(item.key)} style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5, padding: 8, borderRadius: 12, border: value === item.key ? '2px solid #e97824' : '2px solid #eee', background: value === item.key ? '#fff3e6' : '#faf8f4', color: '#33281f', cursor: 'pointer' }}>
        {NEW_KEYS.has(item.key) && <span style={{ alignSelf: 'flex-start', fontSize: 10, color: '#a34706', fontWeight: 700 }}>NEW</span>}
        <img src={item.imageUrl} alt="" loading="lazy" style={{ width: '100%', height: 85, objectFit: 'contain' }} />
        <span style={{ fontSize: 12, lineHeight: 1.4, fontWeight: value === item.key ? 700 : 500 }}>{item.label}</span>
        {value === item.key && <span style={{ fontSize: 10, color: '#a34706' }}>선택됨</span>}
      </button>)}
    </div>
    <p style={{ margin: 0, fontSize: 12, lineHeight: 1.5, color: '#696969' }}>가구를 고르면 상품 이미지가 적용돼요. 판매 가격은 아래에서 정해 주세요.</p>
  </section>;
}
